import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

import { PaginaAreasComponent } from './pagina-areas/pagina-areas.component';
import { ListarAreasComponent } from './listar-areas/listar-areas.component';

const rutas: Routes = [
  {
    path: '',
    component: PaginaAreasComponent,
    children: [
      { path: 'listar-areas', component: ListarAreasComponent },
      { path: '**', redirectTo: 'listar-areas' }
    ]
  }
];

@NgModule({
  declarations: [],
  imports: [
    RouterModule.forChild( rutas )
  ],
  exports: [
    RouterModule
  ]
})
export class AreasRoutingModule { }
